import { createMailRuOneTapCallbackModel } from '@cian/api-models/monolith-python/auth/mailru-onetap-callback';
export function mrOAuthAuthenticate(httpApi, parameters) {
  return httpApi.fetch(createMailRuOneTapCallbackModel({
    parameters: parameters,
    hostType: 'ud-api'
  }));
}
export { EMailRuOneTapCallbackStatus as EMROAuthAuthenticateStatus } from '@cian/api-models/monolith-python/auth/mailru-onetap-callback';